<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
	page: {
	},
	components: {
		ChangePrice: () => lazyLoadComponent(import('./ChangePrice')),
	},
	filters: {

	},

	props: {
		merchantProducts: {
			type: Array,
			required: true,
		},
		serviceCategory: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			activeNames: [],
			filterDateRange: [], // 起始日期/結束日期
			changePriceLength: [
				{
					type: 'second'
				}, {
					type: 'change'
				}
			]
		}
	},
	computed: {

	},
	watch: {

	},
	created() {

	},
	methods: {
		toClick() { },
		addChangePrice() {
			this.changePriceLength.push({})
		}
	},
}
</script>
<template>
	<div>
		<div class="isStylePageContent">
			<div class="mb-3" :class="$style.changePriceTop">
				<h4 class="form-block-title">調價設定</h4>
				<div>
					<el-button class="is-round" type="primary">
						<BaseIcon name="plus" /> 新增第二隻{{ $t('reserve.CLIENT')}}折扣
					</el-button>
					<el-button class="is-round" type="primary" @click="addChangePrice">
						<BaseIcon name="plus" /> 新增調價時段
					</el-button>
				</div>
			</div>
			<el-row :gutter="20">
				<el-col :span="24">
					<div>
						<div style="margin-bottom: 30px;">
							<template>
								<div v-for="item in changePriceLength">
									<ChangePrice :open-type="item.type" />
								</div>
							</template>
						</div>
					</div>
				</el-col>
			</el-row>

		</div>
	</div>
</template>

<style lang="scss" module>
.changePriceTop {
	display: flex;
	justify-content: space-between;
}



.collapseMargin {
	margin-top: 10px;
	margin-bottom: 10px;
}
</style>